import { useEffect, useState } from "react";
import { fetchCurrentChannelInfo } from "../utils/twitchApi";
import useTwitchAuth from "./useTwitchAuth";
export default (function () {
    var auth = useTwitchAuth();
    var _a = useState(), channelName = _a[0], setChannelName = _a[1];
    useEffect(function () {
        if (!auth)
            return;
        fetchCurrentChannelInfo(auth)
            .then(function (newChannelInfo) {
            if (typeof (newChannelInfo === null || newChannelInfo === void 0 ? void 0 : newChannelInfo.broadcaster_login) === "string") {
                setChannelName(newChannelInfo.broadcaster_login.toLowerCase());
            }
        })
            .catch(function (e) {
            console.error("Failed to fetch channel info", e);
            return undefined;
        });
    }, [auth]);
    return channelName;
});
